import React from 'react'
import Modal from '@material-ui/core/Modal'
import { IconButton, Grid, Typography } from '@material-ui/core'
import c from 'classnames'
import closeIcon from '../../../assetss/img/closeModalIcon.svg'
import { useStyles } from './style'

const DialogModal = ({ open, onClose, children, width, maxWidth, height = '', maxHeight = '', closeBtn, top, customModal, newTitle }) => {
  const classes = useStyles()

  return (
    <Modal open={open} onClose={onClose}>
      <div className={c(classes.paper, customModal && customModal)} style={{ maxWidth: maxWidth, width: width, height: height, maxHeight: maxHeight, top: top }}>
        {closeBtn && (
          <Grid className={c(newTitle && classes.newTitleModal)} container justify='flex-end'>
            {newTitle && (
              <Typography className={classes.widthNewTitle}>{newTitle}</Typography>
            )}
            <IconButton onClick={onClose} className={classes.iconCloseBtn}>
              <img src={closeIcon} aly='closeIcon' className={classes.closeIcon} />
            </IconButton>
          </Grid>
        )}
        {children}
      </div>
    </Modal>
  )
}

export default DialogModal
